'use strict';

var React = require('react');
var Episode = require('../episodes/Episode.jsx');
var LinkButton = require('../elements/LinkButton.jsx');


var MoreEpisodesButton = React.createClass({

	displayName: 'MoreEpisodesButton',

	propTypes: {
		visibleEpisodes: React.PropTypes.number.isRequired
	},

	render: function () {
		var program = this.props.program;
		var amount = program.episodes.length;
		var visibleEpisodes = this.props.visibleEpisodes;
		var buttonText = 'Se alla avsnitt';
		var destinations = {
			'PLAY': {
				suffix: 'play',
				name: 'SVT Play'
			},
			'FLOW': {
				suffix: 'flow',
				name: 'SVT Flow'
			},
			'KIDS': {
				suffix: 'kids',
				name: 'Barnkanalen'
			}
		};
		var destination;

		if (amount <= visibleEpisodes) {
			return false;
		}

		destination = destinations[program.primaryDestination] ? destinations[program.primaryDestination] : false;

		return (
			<div className="svtse_latest-episodes__navigation">
				<LinkButton url={program.episodes[0].playUrl} theme={destination.suffix}>
					{buttonText}
				</LinkButton>
			</div>
		);
	}
});


module.exports = React.createClass({
	displayName: 'LatestEpisodes',


	propTypes: {
		program: React.PropTypes.shape({}).isRequired,
		visibleEpisodes: React.PropTypes.number
	},


	getDefaultProps: function () {
		return {
			visibleEpisodes: 3
		};
	},


	_getLatestEpisodes: function () {
		var latestEpisodes = null;
		var program = this.props.program;

		if (program && program.episodes && program.episodes.length > 0) {
			latestEpisodes = program.episodes.slice(0, this.props.visibleEpisodes);
		}

		return latestEpisodes;
	},


	render: function () {
		var episodes = this._getLatestEpisodes();
		var program = this.props.program;

		if (!episodes) {
			return false;
		}

		return (
			<div className="svtse_latest-episodes">
				{episodes.map(function (episode, index) {
					return <Episode program={program} episode={episode} key={index} />;
				})}


				<MoreEpisodesButton program={program} visibleEpisodes={this.props.visibleEpisodes} />
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/episodes/LatestEpisodes.jsx
 **/